// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__31Z8j","inner":"Form_inner__2CPu4","range":"Form_range__3Mdeg","name":"Form_name__1enPM","actions":"Form_actions__3LSdJ"};